import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountOperations = _resolveComponent("AccountOperations")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('menu.items.accountOperations'),
    "dialog-class": "modal-xl",
    "body-class": "p-0",
    modelValue: _ctx.accountToShow !== null,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($event === false && (_ctx.closeModal())))
  }, {
    default: _withCtx(() => [
      (_ctx.accountToShow)
        ? (_openBlock(), _createBlock(_component_AccountOperations, {
            key: 0,
            account: _ctx.accountToShow,
            class: "modal-card"
          }, null, 8, ["account"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeModal()), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}